











import Vue from 'vue'
import XDropdown, {
  OptionEntry,
} from '@/components/atoms/Dropdown/XDropdown.vue'
import { Query } from '@/types/generated/graphql'
import STORE_LIST_QUERY from '@/graphql/partner/stores.gql'

type Methods = {
  onChange: (v: Props['value']) => void
  isRequired: () => boolean
}

type Data = {
  stores?: OptionEntry<string>[]
}

type Props = {
  value?: string
  partnerId: string
  hasEmptyItem: boolean
  rules?: string | Record<string, boolean>
}

export default Vue.extend<Data, Methods, {}, Props>({
  inheritAttrs: false,
  name: 'StorePicker',
  components: { XDropdown },
  props: {
    value: {
      type: String,
      required: false,
    },
    partnerId: {
      type: String,
      required: true,
    },
    hasEmptyItem: {
      type: Boolean,
      default: true,
    },
    rules: {
      type: [String, Object],
      required: false,
    },
    // ...rest (inherit attrs from x-dropdown)
  },
  methods: {
    onChange(v) {
      this.$emit('input', v)
    },
    isRequired() {
      if (this.rules) {
        if (typeof this.rules === 'string') {
          return this.rules.includes('required')
        } else {
          return this.rules.required
        }
      }
      return false
    },
  },
  apollo: {
    stores: {
      query: STORE_LIST_QUERY,
      variables() {
        return {
          input: { partnerId: this.partnerId },
        }
      },
      update(data: Query) {
        this.$emit('loaded', data.stores)
        const options: Data['stores'] = data.stores.map((store) => {
          return {
            value: store.storeId,
            label: store.name,
          }
        })
        if (!this.hasEmptyItem) {
          return options
        }
        return this.isRequired()
          ? [{ value: undefined, label: '' }, ...options]
          : [{ value: undefined, label: this.$tc('common.all') }, ...options]
      },
    },
  },
})
